export const companies_details = [
  {
    key: "1",
    CompanyName: "BrightWave Innovations",
    Email: "michael@example.com",
    AccountURL: "bwi.example.com",
    Plan: "Advanced (Monthly)",
    CreatedDate: "12 Sep 2024",
    Image: "company-01.svg",
    Status: "Active",
  },
  {
    key: "2",
    CompanyName: "Stellar Dynamics",
    Email: "sophie@example.com",
    AccountURL: "sd.example.com",
    Plan: "Basic (Yearly)",
    CreatedDate: "24 Oct 2024",
    Image: "company-02.svg",
    Status: "Active",
  },
  {
    key: "3",
    CompanyName: "Quantum Nexus",
    Email: "cameron@example.com",
    AccountURL: "qn.example.com",
    Plan: "Advanced (Monthly)",
    CreatedDate: "18 Feb 2024",
    Image: "company-03.svg",
    Status: "Active",
  },
  {
    key: "4",
    CompanyName: "EcoVision Enterprises",
    Email: "doris@example.com",
    AccountURL: "eve.example.com",
    Plan: "Advanced (Monthly)",
    CreatedDate: "17 Oct 2024",
    Image: "company-04.svg",
    Status: "Active",
  },
  {
    key: "5",
    CompanyName: "Aurora Technologies",
    Email: "thomas@example.com",
    AccountURL: "at.example.com",
    Plan: "Enterprise (Monthly)",
    CreatedDate: "20 Jul 2024",
    Image: "company-05.svg",
    Status: "Active",
  },
  {
    key: "6",
    CompanyName: "BlueSky Ventures",
    Email: "kathleen@example.com",
    AccountURL: "bsv.example.com",
    Plan: "Advanced (Monthly)",
    CreatedDate: "10 Apr 2024",
    Image: "company-06.svg",
    Status: "Active",
  },
  {
    key: "7",
    CompanyName: "TerraFusion Energy",
    Email: "bruce@example.com",
    AccountURL: "tfe.example.com",
    Plan: "Enterprise (Yearly)",
    CreatedDate: "29 Aug 2024",
    Image: "company-07.svg",
    Status: "Active",
  },
  {
    key: "8",
    CompanyName: "UrbanPulse Design",
    Email: "estelle@example.com",
    AccountURL: "upd.example.com",
    Plan: "Basic (Monthly)",
    CreatedDate: "22 Feb 2024",
    Image: "company-08.svg",
    Status: "Inactive",
  },
  {
    key: "9",
    CompanyName: "Nimbus Networks",
    Email: "stephen@example.com",
    AccountURL: "nn.example.com",
    Plan: "Basic (Yearly)",
    CreatedDate: "03 Nov 2024",
    Image: "company-09.svg",
    Status: "Active",
  },
  {
    key: "10",
    CompanyName: "Epicurean Delights",
    Email: "angela@example.com",
    AccountURL: "ed.example.com",
    Plan: "Advanced (Monthly)",
    CreatedDate: "17 Dec 2024",
    Image: "company-10.svg",
    Status: "Active",
  },
];
